module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNjAiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCA2MCAxOCI+PGRlZnM+PHBhdGggaWQ9ImludTVhIiBkPSJNMTA5NCA2MDRzLTMuMDg1LTE4LjA0LTE5LjgzNi0xOGMtMTIuMzIzLjAyOC0xNS43ODQgNy44MjYtMTUuNzg0IDcuODI2cy03LjI0Ny00LjExMS0xNC4yMTQtMS4zMWMtOS4wODYgMy42NS0xMC4xNjYgMTEuMjctMTAuMTY2IDExLjI3czM0LjI1OC4yMTQgNjAgLjIxNCIvPjwvZGVmcz48Zz48ZyBvcGFjaXR5PSIuMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwMzQgLTU4NikiPjx1c2UgZmlsbD0iI2ZmZiIgeGxpbms6aHJlZj0iI2ludTVhIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./static/img/cloud-5.svg
// module id = 13
// module chunks = 0